<template>
    <div v-if="isDisplay">
         <Tag
            type="border"
            :closable="attrs.mode == 'edit'"
            color="success"
            v-for="(el, i) in keywords" :key="i" @on-close="handleClose(i)">
            {{el}}
        </Tag>
        <template v-if="canAdd">
            <Input :maxlength="15" v-if="attrs.mode == 'edit'" v-model="inputValue" :type="inputType" :autosize="true" placeholder="输入关键词，并回车" style="width: 130px;" @on-enter="handleEnter" />
            <Button v-if="attrs.mode == 'edit'" type="success" icon="md-checkmark" size="small"  @click="handleEnter">添加</Button>
        </template>
    </div>
</template>
<script>
    /**
     * 关键词的输入
     * 2020-11-04 modify by wxf
     * 增加条件判断是否显示组件
     */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyKeyword',
        mixins: [CompDisplayMixin],
        props: {
            value: {
                type: [Array],
                default: _ => []
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            page: {
                type: Object,
                default:_ => new Object()
            }
        },
        data () {
            return {
                inputType: 'text',
                keywords: [], // 关键词列表
                inputValue: ''
            }
        },
        watch: {
            value () {
                this.initKeywords()
            }
        },
        computed: {
            ...mapGetters(['userInfo']),
            // 标识是否可以继续添加
            canAdd () {
                let bool = true
                if (this.attrs.max && this.attrs.max > 0 && this.keywords.length >= this.attrs.max) {
                    bool = false
                }
                return bool
            }
        },
        created () {
            this.initKeywords()
            if (this.attrs.isTextarea) {
                this.inputType = 'textarea'
            }
        },
        methods: {
            initKeywords () {
                if (this.value.length > 0) {
                    this.keywords = JSON.parse(JSON.stringify(this.value))
                } else { // 没有数据的时候 清空一下
                    this.keywords = []
                }
            },
            /**
             * 输入框回车的监听
             */
            handleEnter () {
                if (this.attrs.isTextarea) {
                    let arr = this.inputValue.split('\n')
                    let addarr = []
                    arr.map((item, index)=> { // 排除空格等
                        if (item && item.length > 0) {
                            addarr.push(item)
                        }
                    })
                    if (addarr && addarr.length > 0) {
                        this.keywords.push.apply(this.keywords, addarr)
                        this.inputValue = ''
                        this.$emit('input', this.keywords)
                    }
                } else {
                    if (this.inputValue.length > 0) {
                        this.keywords.push(this.inputValue)
                        this.inputValue = ''
                        this.$emit('input', this.keywords)
                    }
                }
            },
            /**
             * 关键词的删除
             */
            handleClose (index) {
                this.keywords.splice(index, 1)
                this.$emit('input', this.keywords)
            }
        }
    }
</script>




// WEBPACK FOOTER //
// ../projectCore/src/components/keyword/src/index.vue